export default __webpack_public_path__ + "static/media/IconDesc_XmasBall_Blue.256.da08c70c.png";